function ConstructAggregateSetting(startDate, endDate) {  
    let gridAggregateColumnSettings = [
      { aggregate: "sum", field: "TotalSales" },
    ];
    for(var d = startDate; d <= endDate; d.setDate(d.getDate() + 1))
      {
        var date = (d.getMonth()+1)+"/"+ d.getDate()+"/"+ d.getFullYear();
        gridAggregateColumnSettings.push({ aggregate: "sum", field: date });
        gridAggregateColumnSettings.push({ aggregate: "sum", field: date+"Count" });
      }
      return gridAggregateColumnSettings
    }

    export {ConstructAggregateSetting};